/**
 * Tokens de design partagés par le layout utilisateur.
 * Une seule palette pour sidebar, header et menu mobile.
 */
export const glassPanel =
  "bg-white/10 dark:bg-gray-800/50 backdrop-blur-lg rounded-2xl shadow-xl border border-slate-200/50 dark:border-slate-600/50";
export const surface = "bg-white dark:bg-gray-800";
export const surfaceMuted = "bg-gray-100 dark:bg-gray-700/50";
export const borderSub = "border-gray-200 dark:border-gray-700";
export const btnActive = "bg-gray-900 dark:bg-gray-600 text-white";
export const btnHover = "hover:bg-gray-100 dark:hover:bg-gray-700";
export const textPrimary = "text-gray-900 dark:text-white";
export const textSecondary = "text-gray-600 dark:text-gray-400";
export const roundedPanel = "rounded-xl";
export const roundedBtn = "rounded-lg";
